import React from 'react';
import PropTypes from 'prop-types';

import { schedulesClassesPropTypes } from 'constants/propTypes';
import { Autocomplete } from 'components/Form';

import messages from '../../ScheduleForm.messages';
import './SelectClassInput.scss';

const SelectClassInput = ({ classes, onAddClassClick, ...rest }) => {
  const options = classes
    .map(({ name, id }) => ({
      label: name,
      value: id,
    }))
    .concat({
      label: messages.inputs.class.add,
      value: 'add-new-class',
      isFilterable: false,
      labelProps: {
        className: 'select-class-input__add-class-button',
        onClick: () => onAddClassClick(),
      },
    });

  return <Autocomplete {...rest} options={options} placeholder={messages.inputs.class.select} />;
};

SelectClassInput.propTypes = {
  classes: schedulesClassesPropTypes,
  onAddClassClick: PropTypes.func,
};

export default SelectClassInput;
